import React, { useContext } from 'react';
import theme from '../theme/theme';
import { globalStore } from '../state/store';
import { Box, Button, Dialog, DialogActions, DialogContent,
    DialogTitle, DialogContentText, Divider, Grid, InputAdornment,
    List, ListItem, ListItemIcon, ListItemText,
    TextField, useMediaQuery, 
    Typography} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheckCircle, faEnvelope, faPaperPlane, faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons';

const LeagueManager = ({}) => {

    const [state] = useContext(globalStore);

    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const isLeagueManager = Boolean(state.league) && Boolean(state.league.managers) && state.league.managers.includes(state.user.uid)
    const [addingUsers, setAddingUsers] = React.useState(false);
    const [email, setEmail] = React.useState({valid: false, qty: 0, value: ''});

    const [dialogOpen, setDialogOpen] = React.useState(null);

    const handleClickOpen = (screen) => {
        setDialogOpen(screen);
    };
    
    const handleClose = () => {
        setDialogOpen(null);
        setAddingUsers(false);
        setEmail({valid: false, qty: 0, value: ''})
    };

    const handleEmailUpdate = (newVal) => {

        const emailList = newVal.split(/[;,]/); // Split by comma or semicolon
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        let allValid = true;
      
        for (const email of emailList) {
          const trimmedEmail = email.trim(); // Remove leading/trailing whitespace
          if (trimmedEmail !== '' && !emailRegex.test(trimmedEmail)) {
            allValid = false;
            break; // Exit the loop on the first invalid email
          }
        }
      
        setEmail({ 
            valid: allValid, 
            qty: emailList.filter((em) => em.trim().length > 0).length, 
            value: newVal })

    }

    return (
    <>
    {isLeagueManager && !state.closedForEditing  ? 
    <Grid container direction="row" justifyContent={"space-between"} spacing={2} sx={{mt: 2}}>
        {/*<Grid item xs={12} sm={6}>
            <Button variant="outlined" fullWidth size='small' color="primary" sx={{backgroundColor: theme.palette.primary.contrastText}}
            onClick={e => handleClickOpen('manage')}>
            <FontAwesomeIcon icon={faCogs} style={{ display: 'inline', marginRight: '10px'}} />
            Manage League
            </Button>
        </Grid>*/}
        <Grid item xs={12}>
            <Button variant="contained" fullWidth size='small' color="primary" /*sx={{backgroundColor: theme.palette.primary.contrastText}}*/
            onClick={e => handleClickOpen('invite')}>
            <FontAwesomeIcon icon={faUserPlus} style={{ display: isSmUp ? 'none' : 'inline', marginRight: '10px'}} />
            Manage Users
            <FontAwesomeIcon icon={faUserPlus} style={{ display: isSmUp ? 'inline' : 'none', marginLeft: '10px'}} />
            </Button>
        </Grid>
    </Grid>
    :''}

    <Dialog
    fullWidth={true}
    maxWidth={"sm"}
    open={Boolean(dialogOpen)}
    onClose={handleClose}
    >
    <DialogTitle sx={{padding: '30px 30px'}}>
        <span style={{fontWeight: 900}}>
        {/*dialogOpen === 'invite' ?
            "Invite Users" : */
            "Manage League"}
        </span>
    </DialogTitle>
    <DialogContent sx={{padding: '30px 30px'}}>
        <DialogContentText>
        {addingUsers ? 
            "Add email addresses separated by a comma (,) or semicolon (;)" :
            "Manage the users that are invited to this league" 
        }
        </DialogContentText>
        

        { addingUsers ?

        <Grid direction="column" sx={{mt: 4, mb: 1}}>
            <Grid item>
                <TextField
                //autoFocus
                fullWidth
                multiline
                variant="outlined"
                id="email"
                placeholder={"Email address(es)..."}
                //label="Email Address"
                name="email"
                autoComplete="email"
                //value={email.value}
                onChange={e => handleEmailUpdate(e.target.value.toLowerCase())}
                //onKeyDown={_handleKeyDown}
                InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                      <FontAwesomeIcon 
                      icon={faEnvelope} 
                      color={theme.palette.primary.main} />
                  </InputAdornment>
                  ),
                }}
                />  
            </Grid>
            <Grid sx={{mt: 4}}>
                <Typography sx={{textAlign: 'center'}}>You have <span style={{fontWeight: 700}}>{state.league.maxPlayers - state.league.invited.length} invitations</span> left</Typography>
                <Typography sx={{textAlign: 'center'}}>You are inviting <span style={{fontWeight: 700,
                    color: 
                    email.qty === 0 ?
                        theme.palette.grey[900] :
                    email.qty > (state.league.maxPlayers - state.league.invited.length) ? 
                        theme.palette.error.main :
                        theme.palette.success.main
                }}>{email.qty} users</span></Typography>
            </Grid>
        </Grid>

        :
        <List>
        {state.league.invited
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
        .map((email, i) => (

            <>
            <ListItem fullWidth key={i}
            secondaryAction={
                state.league.players.filter((p) => p.email === email).length > 0 ?
                null :
                <Button edge="end" aria-label="delete" size="small" color="error"
                sx={{pr:1, pl:1}}>
                  Withdraw&nbsp;&nbsp;<FontAwesomeIcon icon={faTrash} />
                </Button>
            }>
                <ListItemIcon>
                    <FontAwesomeIcon 
                    style={{
                        fontSize: '18px', 
                        color: state.league.players.filter((p) => p.email === email).length > 0 ?
                            theme.palette.success.main : theme.palette.grey[700]
                    }}
                    icon={
                        state.league.players.filter((p) => p.email === email).length > 0 ?
                        faCheckCircle : faPaperPlane} />
                </ListItemIcon>
                <ListItemText
                    primary={state.league.players.filter((p) => p.email === email).length > 0 ? state.league.players.filter((p) => p.email === email)[0].displayName : email}
                    secondary={
                        state.league.players.filter((p) => p.email === email).length > 0 ?
                        'Invite accepted' : 'Invite sent'
                    }
                />
            </ListItem>
            <Divider component="li" />
            </>
        ))}
        </List>
        }

    </DialogContent>
    <DialogActions
    sx={{padding: '15px 15px', display: 'flex', justifyContent: 'space-between'}}>
        {
        <>
        <Button variant="outlined" onClick={addingUsers ? 
                e => { setAddingUsers(false); setEmail({valid: false, qty: 0, value: ''}) } : 
                e => handleClose()}>
            <FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;
            {addingUsers ? "Return" : "Cancel"}
        </Button>
        <Button variant={"contained"} onClick={e => setAddingUsers(!addingUsers)}
            disabled={addingUsers && 
                (!email.valid || email.qty > (state.league.maxPlayers - state.league.invited.length))}>
            {addingUsers ? "Send Invite" : "Invite users"}
            &nbsp;&nbsp;<FontAwesomeIcon icon={addingUsers ? faPaperPlane : faUserPlus} />
        </Button>
        </>}
    </DialogActions>
    </Dialog>
    </>
    )

};
export default LeagueManager;